import { useContext } from 'react';
import { ToastContext } from '../../contexts/ToastContext';

export const useToastContext = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToastContext must be used inside ToastProvider');
  }
  return ctx;
};
